import { Col, Row } from "react-bootstrap";

import { Chapter } from "../../components/Chapter";
import React from 'react'
import {
  useParams
} from "react-router-dom";

export const Vineyards = () => {
  let { nome } = useParams();
  React.useEffect(() => {
    if (nome) {
      const ele = document.getElementById(nome);
      const navHeight = window.innerHeight *0.15;
      window.scrollTo(ele.offsetLeft, ele.offsetTop-navHeight);
    }
  },)

  const chapters = [
    {
      name: "sialic",
      title: "Vigneto Sialic",
      text: "The vineyard represents one of the jewels of our land. Located on steep terraced slopes at an altitude of about 600 meters above sea level, this vineyard, established in 2016, occupies an area of about 1 hectare and is planted with 2500 Sauvignon Blanc vines. The deep roots of the vines penetrate a subsoil rich in siliceous rocks, giving the grapes a distinctive character. The south-facing exposure ensures abundant sunlight, while the temperature fluctuations between day and night enhance the unique aromas of the grapes. Framed by forests and mountains, this vineyard produces Sauvignon Blanc grapes, which form the basis for our wine Sialic.",
      image: "/images/vineyards/sialic.jpg",
      buttons: [{
        link: "https://www.google.com/maps/d/edit?mid=1NLLZMyzg_hzIW1178RiYSr_U3bpQNwI&usp=sharing",
        bText: 'Vineyard Map'
      }]
    },
    {
      name: "bram",
      title: "Vigneto Bram",
      text: "Hidden at the foot of the imposing Monte Viso, the vineyard gracefully stretches across a gentle slope, covering an area equivalent to one &quot;giornata piemontese&quot; (0,38 hectares). In this place, we carefully and dedicatedly cultivate 2000 Pinot Noir vines, following the Guyot pruning system. This vineyard is located near the historic Brichet vineyard. From here, the eyes are captured by a panoramic view embracing the iconic Rocca di Cavour, creating a perfect union between viticulture and landscape. The history of this vineyard began in 2017, when we decided to explore further the winemaking potential of our land by planting the first Pinot Noir vines. It is from these vines that the grapes for our Bram are born, a new engaging chapter in our quest to create high-quality wines.",
      image: "/images/vineyards/bram.jpg",
      buttons: [{
        link: "https://www.google.com/maps/d/edit?mid=1Xg5-_euegGJajsHbspBcfrL_qDXcQKI&usp=sharing",
        bText: 'Vineyard Map'
      }]
    },
    {
      name: "brichet",
      title: "Vigneto Brichet",
      text: "A place where winemaking tradition blends with the unique characteristics of the terroir, the vineyard stretches across a gentle slope covering an area of about half a hectare. This old vineyard was planted in the 1960s by Agù Costanzo, reflecting the customs of that era. The vineyard hosts about 3000 vines, following the traditional practice of cultivating a wide range of varieties to satisfy the personal preferences of the owner. Among the varieties cultivated are Barbera, Bonarda, Dolcetto, Freisa, as well as white grape varieties such as Malvasia and Arneis. These old vines produce the grapes that form the heart of Brichet, a wine that reflects the soul of this vineyard. This vineyard is a faithful custodian of the history and winemaking art of our family.",
      image: "/images/vineyards/brichet.jpg",
      buttons: [{
        link: "https://www.google.com/maps/d/edit?mid=1V_S0qRc1beZb3m5nPikZc7-y2rM4DkY&usp=sharing",
        bText: 'Vineyard Map'
      }]
    },

  ];

  return (<>
    <Row>
      <Col md={12} className="text-center" >
      <h2>Our Vineyards: The Heart of the Winery<br /><small>&quot;Wine is made in the vineyard, not in the winery.&quot;</small></h2>
      </Col>
    </Row>
    <Row style={{ padding: '10vh' }}>
      <Col md={12} className="text-center" >
      <p>
          Our vineyards represent the beating heart of Agù Winery. The philosophy guiding our cultivation is one of respect for nature and love for the land. We apply natural cultivation methods, limiting treatments to copper and sulfur, in harmony with the surrounding environment. 
          Soil coverage with grassing, the renunciation of synthetic chemicals and encouragement of deep root growth are integral to our viticultural practices. These efforts allow us to produce high-quality grapes, rich in character and nuances, and to translate the unique terroir of our land into our wines. 
          Our vineyards are a vibrant environment of biodiversity, where vines, native plants, beneficial insects and wildlife coexist in harmony. This rich biodiversity is crucial to our sustainable approach to viticulture.
        </p>
      </Col>
    </Row>
    {chapters.map((chapter, index) => (
      <Chapter
        key={index}
        chapter={chapter}
        index={index}
        startBlack={true} />
    ))}



  </>)
}